module.exports = __webpack_public_path__ + "84900f4b6f1d28bdd65e131ab388340b.png";